import { get, post, del, put as update } from "helpers/api_helper";

const getByQuery = async query => {
  return await get(`/api/ItemShippingFee/getByQuery`, { params: query });
};

export const itemShippingFeeService = {
  getByQuery,
};
